import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useStructuraAuth } from './useStructuraAuth'
import { useTranslation } from '@structura/i18n'

interface AdminRouteProps {
  children: React.ReactNode
}

// Route guard for Admin section - checks the server-authoritative admin role from JWT
const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const authState = useStructuraAuth()
  const location = useLocation()
  const { t } = useTranslation()

  // While auth state is resolving, show a spinner
  if (authState.isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">{t('auth.common.loading')}</span>
        </div>
      </div>
    )
  }

  // If not logged in, redirect to account/login page
  if (!authState.isAuthenticated || authState.userEmail === undefined) {
    return <Navigate to="/account" state={{ from: location, message: t('auth.route.signInToPage') }} replace />
  }

  if (!authState.isAdmin) {
    return <Navigate to="/" state={{ from: location, message: t('auth.route.noAdminPermission') }} replace />
  }

  return <>{children}</>
}

export default AdminRoute


